(function (window) {
  'use strict';
  window.LEAVES_CONFIGURATOR_VARIANT_MAP = {
  "generatedAt": "2026-10-13T03:20:29.515Z",
  "source": "published leaves-lighting, leaves-lnt, leaves-color-bridge-cable",
  "apiVersion": "2026-07",
  "productHandles": [
    "leaves-parts",
    "leaves-color-bridge-cable",
    "leaves-lnt",
    "leaves-lighting",
    "户外定制灯具",
    "2套灯具组合",
    "彩桥线",
    "lighting",
    "lnt",
    "配件",
    "outdoor-wrap-around-light-color-bridge",
    "outdoor-suspended-light-color-bridge",
    "outdoor-mounted-hanging-light-color-bridge",
    "outdoor-ceiling-hanging-light-color-bridge",
    "outdoor-wall-track-light-lnt",
    "outdoor-lnt-track-system",
    "outdoor-ceiling-track-light-lnt",
    "outdoor-ground-spike-lightcolor-bridge"
  ],
  "installationsById": {
    "wrap_around": {
      "cartVariantId": "47819810177250",
      "pluginOptionSetId": "165144",
      "productHandle": "outdoor-wrap-around-light-color-bridge"
    },
    "suspended": {
      "cartVariantId": "47819813093602",
      "pluginOptionSetId": "165143",
      "productHandle": "outdoor-suspended-light-color-bridge"
    },
    "mounted_hanging": {
      "cartVariantId": "47819816304866",
      "pluginOptionSetId": "159723",
      "productHandle": "outdoor-mounted-hanging-light-color-bridge"
    },
    "ceiling_hanging": {
      "cartVariantId": "47819817910498",
      "pluginOptionSetId": "159722",
      "productHandle": "outdoor-ceiling-hanging-light-color-bridge"
    },
    "wall_track": {
      "cartVariantId": "47819800379618",
      "pluginOptionSetId": "165141",
      "productHandle": "outdoor-wall-track-light-lnt"
    },
    "floor_track": {
      "cartVariantId": "47266789425378",
      "pluginOptionSetId": "150880",
      "productHandle": "outdoor-lnt-track-system"
    },
    "ceiling_track": {
      "cartVariantId": "47819807260898",
      "pluginOptionSetId": "165142",
      "productHandle": "outdoor-ceiling-track-light-lnt"
    },
    "ground_spike": {
      "cartVariantId": "47819818893538",
      "pluginOptionSetId": "159720",
      "productHandle": "outdoor-ground-spike-lightcolor-bridge"
    }
  },
  "cablesByColorAndLength": {
    "black": {
      "3": {
        "cartVariantId": "67673810796770",
        "adminGid": "gid://shopify/ProductVariant/67673810796770",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 3,
        "priceSnapshot": "29.68",
        "availableForSale": true
      },
      "4": {
        "cartVariantId": "67673810829538",
        "adminGid": "gid://shopify/ProductVariant/67673810829538",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 4,
        "priceSnapshot": "30.24",
        "availableForSale": true
      },
      "5": {
        "cartVariantId": "67673810862306",
        "adminGid": "gid://shopify/ProductVariant/67673810862306",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 5,
        "priceSnapshot": "30.80",
        "availableForSale": true
      },
      "6": {
        "cartVariantId": "67673810895074",
        "adminGid": "gid://shopify/ProductVariant/67673810895074",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 6,
        "priceSnapshot": "31.36",
        "availableForSale": true
      },
      "7": {
        "cartVariantId": "67673810927842",
        "adminGid": "gid://shopify/ProductVariant/67673810927842",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 7,
        "priceSnapshot": "31.92",
        "availableForSale": true
      },
      "8": {
        "cartVariantId": "67673810960610",
        "adminGid": "gid://shopify/ProductVariant/67673810960610",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 8,
        "priceSnapshot": "32.49",
        "availableForSale": true
      },
      "9": {
        "cartVariantId": "67673810993378",
        "adminGid": "gid://shopify/ProductVariant/67673810993378",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 9,
        "priceSnapshot": "33.05",
        "availableForSale": true
      },
      "10": {
        "cartVariantId": "67673811026146",
        "adminGid": "gid://shopify/ProductVariant/67673811026146",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 10,
        "priceSnapshot": "33.61",
        "availableForSale": true
      },
      "11": {
        "cartVariantId": "67673811058914",
        "adminGid": "gid://shopify/ProductVariant/67673811058914",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 11,
        "priceSnapshot": "34.17",
        "availableForSale": true
      },
      "12": {
        "cartVariantId": "67673811091682",
        "adminGid": "gid://shopify/ProductVariant/67673811091682",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 12,
        "priceSnapshot": "34.73",
        "availableForSale": true
      },
      "13": {
        "cartVariantId": "67673811124450",
        "adminGid": "gid://shopify/ProductVariant/67673811124450",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 13,
        "priceSnapshot": "35.29",
        "availableForSale": true
      },
      "14": {
        "cartVariantId": "67673811157218",
        "adminGid": "gid://shopify/ProductVariant/67673811157218",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 14,
        "priceSnapshot": "35.85",
        "availableForSale": true
      },
      "15": {
        "cartVariantId": "67673811189986",
        "adminGid": "gid://shopify/ProductVariant/67673811189986",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黑色",
        "lengthMeters": 15,
        "priceSnapshot": "36.41",
        "availableForSale": true
      }
    },
    "blue": {
      "3": {
        "cartVariantId": "67673811222754",
        "adminGid": "gid://shopify/ProductVariant/67673811222754",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 3,
        "priceSnapshot": "34.25",
        "availableForSale": true
      },
      "4": {
        "cartVariantId": "67673811255522",
        "adminGid": "gid://shopify/ProductVariant/67673811255522",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 4,
        "priceSnapshot": "36.33",
        "availableForSale": true
      },
      "5": {
        "cartVariantId": "67673811288290",
        "adminGid": "gid://shopify/ProductVariant/67673811288290",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 5,
        "priceSnapshot": "38.41",
        "availableForSale": true
      },
      "6": {
        "cartVariantId": "67673811321058",
        "adminGid": "gid://shopify/ProductVariant/67673811321058",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 6,
        "priceSnapshot": "40.50",
        "availableForSale": true
      },
      "7": {
        "cartVariantId": "67673811353826",
        "adminGid": "gid://shopify/ProductVariant/67673811353826",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 7,
        "priceSnapshot": "42.58",
        "availableForSale": true
      },
      "8": {
        "cartVariantId": "67673811386594",
        "adminGid": "gid://shopify/ProductVariant/67673811386594",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 8,
        "priceSnapshot": "44.66",
        "availableForSale": true
      },
      "9": {
        "cartVariantId": "67673811419362",
        "adminGid": "gid://shopify/ProductVariant/67673811419362",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 9,
        "priceSnapshot": "46.74",
        "availableForSale": true
      },
      "10": {
        "cartVariantId": "67673811452130",
        "adminGid": "gid://shopify/ProductVariant/67673811452130",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 10,
        "priceSnapshot": "48.83",
        "availableForSale": true
      },
      "11": {
        "cartVariantId": "67673811484898",
        "adminGid": "gid://shopify/ProductVariant/67673811484898",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 11,
        "priceSnapshot": "50.91",
        "availableForSale": true
      },
      "12": {
        "cartVariantId": "67673811517666",
        "adminGid": "gid://shopify/ProductVariant/67673811517666",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 12,
        "priceSnapshot": "52.99",
        "availableForSale": true
      },
      "13": {
        "cartVariantId": "67673811550434",
        "adminGid": "gid://shopify/ProductVariant/67673811550434",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 13,
        "priceSnapshot": "55.07",
        "availableForSale": true
      },
      "14": {
        "cartVariantId": "67673811583202",
        "adminGid": "gid://shopify/ProductVariant/67673811583202",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 14,
        "priceSnapshot": "57.16",
        "availableForSale": true
      },
      "15": {
        "cartVariantId": "67673811615970",
        "adminGid": "gid://shopify/ProductVariant/67673811615970",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "蓝色",
        "lengthMeters": 15,
        "priceSnapshot": "59.24",
        "availableForSale": true
      }
    },
    "yellow": {
      "3": {
        "cartVariantId": "67673811648738",
        "adminGid": "gid://shopify/ProductVariant/67673811648738",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 3,
        "priceSnapshot": "34.25",
        "availableForSale": true
      },
      "4": {
        "cartVariantId": "67673811681506",
        "adminGid": "gid://shopify/ProductVariant/67673811681506",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 4,
        "priceSnapshot": "36.33",
        "availableForSale": true
      },
      "5": {
        "cartVariantId": "67673811714274",
        "adminGid": "gid://shopify/ProductVariant/67673811714274",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 5,
        "priceSnapshot": "38.41",
        "availableForSale": true
      },
      "6": {
        "cartVariantId": "67673811747042",
        "adminGid": "gid://shopify/ProductVariant/67673811747042",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 6,
        "priceSnapshot": "40.50",
        "availableForSale": true
      },
      "7": {
        "cartVariantId": "67673811779810",
        "adminGid": "gid://shopify/ProductVariant/67673811779810",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 7,
        "priceSnapshot": "42.58",
        "availableForSale": true
      },
      "8": {
        "cartVariantId": "67673811812578",
        "adminGid": "gid://shopify/ProductVariant/67673811812578",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 8,
        "priceSnapshot": "44.66",
        "availableForSale": true
      },
      "9": {
        "cartVariantId": "67673811845346",
        "adminGid": "gid://shopify/ProductVariant/67673811845346",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 9,
        "priceSnapshot": "46.74",
        "availableForSale": true
      },
      "10": {
        "cartVariantId": "67673811878114",
        "adminGid": "gid://shopify/ProductVariant/67673811878114",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 10,
        "priceSnapshot": "48.83",
        "availableForSale": true
      },
      "11": {
        "cartVariantId": "67673811910882",
        "adminGid": "gid://shopify/ProductVariant/67673811910882",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 11,
        "priceSnapshot": "50.91",
        "availableForSale": true
      },
      "12": {
        "cartVariantId": "67673811943650",
        "adminGid": "gid://shopify/ProductVariant/67673811943650",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 12,
        "priceSnapshot": "52.99",
        "availableForSale": true
      },
      "13": {
        "cartVariantId": "67673811976418",
        "adminGid": "gid://shopify/ProductVariant/67673811976418",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 13,
        "priceSnapshot": "55.07",
        "availableForSale": true
      },
      "14": {
        "cartVariantId": "67673812009186",
        "adminGid": "gid://shopify/ProductVariant/67673812009186",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 14,
        "priceSnapshot": "57.16",
        "availableForSale": true
      },
      "15": {
        "cartVariantId": "67673812041954",
        "adminGid": "gid://shopify/ProductVariant/67673812041954",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "黄色",
        "lengthMeters": 15,
        "priceSnapshot": "59.24",
        "availableForSale": true
      }
    },
    "green": {
      "3": {
        "cartVariantId": "67673812074722",
        "adminGid": "gid://shopify/ProductVariant/67673812074722",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 3,
        "priceSnapshot": "34.25",
        "availableForSale": true
      },
      "4": {
        "cartVariantId": "67673812107490",
        "adminGid": "gid://shopify/ProductVariant/67673812107490",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 4,
        "priceSnapshot": "36.33",
        "availableForSale": true
      },
      "5": {
        "cartVariantId": "67673812140258",
        "adminGid": "gid://shopify/ProductVariant/67673812140258",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 5,
        "priceSnapshot": "38.41",
        "availableForSale": true
      },
      "6": {
        "cartVariantId": "67673812173026",
        "adminGid": "gid://shopify/ProductVariant/67673812173026",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 6,
        "priceSnapshot": "40.50",
        "availableForSale": true
      },
      "7": {
        "cartVariantId": "67673812205794",
        "adminGid": "gid://shopify/ProductVariant/67673812205794",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 7,
        "priceSnapshot": "42.58",
        "availableForSale": true
      },
      "8": {
        "cartVariantId": "67673812238562",
        "adminGid": "gid://shopify/ProductVariant/67673812238562",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 8,
        "priceSnapshot": "44.66",
        "availableForSale": true
      },
      "9": {
        "cartVariantId": "67673812271330",
        "adminGid": "gid://shopify/ProductVariant/67673812271330",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 9,
        "priceSnapshot": "46.74",
        "availableForSale": true
      },
      "10": {
        "cartVariantId": "67673812304098",
        "adminGid": "gid://shopify/ProductVariant/67673812304098",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 10,
        "priceSnapshot": "48.83",
        "availableForSale": true
      },
      "11": {
        "cartVariantId": "67673812336866",
        "adminGid": "gid://shopify/ProductVariant/67673812336866",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 11,
        "priceSnapshot": "50.91",
        "availableForSale": true
      },
      "12": {
        "cartVariantId": "67673812369634",
        "adminGid": "gid://shopify/ProductVariant/67673812369634",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 12,
        "priceSnapshot": "52.99",
        "availableForSale": true
      },
      "13": {
        "cartVariantId": "67673812402402",
        "adminGid": "gid://shopify/ProductVariant/67673812402402",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 13,
        "priceSnapshot": "55.07",
        "availableForSale": true
      },
      "14": {
        "cartVariantId": "67673812435170",
        "adminGid": "gid://shopify/ProductVariant/67673812435170",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 14,
        "priceSnapshot": "57.16",
        "availableForSale": true
      },
      "15": {
        "cartVariantId": "67673812467938",
        "adminGid": "gid://shopify/ProductVariant/67673812467938",
        "productHandle": "leaves-color-bridge-cable",
        "colorValue": "绿色",
        "lengthMeters": 15,
        "priceSnapshot": "59.24",
        "availableForSale": true
      }
    }
  },
  "fixturesByStyle": {
    "CQA-BJW-C-01": {
      "cartVariantId": "47877685903586",
      "adminGid": "gid://shopify/ProductVariant/47877685903586",
      "productHandle": "lighting",
      "sku": "CQA-BJW-C-01",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "CQA-BJW-C-7W-RGBCW": {
      "cartVariantId": "47877685936354",
      "adminGid": "gid://shopify/ProductVariant/47877685936354",
      "productHandle": "lighting",
      "sku": "CQA-BJW-C-7W-RGBCW",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "CQA-DT-7W-RGBCW": {
      "cartVariantId": "47877685969122",
      "adminGid": "gid://shopify/ProductVariant/47877685969122",
      "productHandle": "lighting",
      "sku": "CQA-DT-7W-RGBCW",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "CQA-DT-9W": {
      "cartVariantId": "47877686001890",
      "adminGid": "gid://shopify/ProductVariant/47877686001890",
      "productHandle": "lighting",
      "sku": "CQA-DT-9W",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "CQA-HSB-9W": {
      "cartVariantId": "67673808535778",
      "adminGid": "gid://shopify/ProductVariant/67673808535778",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSB-9W",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSC-7W-DC-RGBCW": {
      "cartVariantId": "67673809125602",
      "adminGid": "gid://shopify/ProductVariant/67673809125602",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-7W-DC-RGBCW",
      "priceSnapshot": "45.63",
      "availableForSale": true
    },
    "CQA-HSC-7W-DC-RGBCW2": {
      "cartVariantId": "47877686067426",
      "adminGid": "gid://shopify/ProductVariant/47877686067426",
      "productHandle": "lighting",
      "sku": "CQA-HSC-7W-DC-RGBCW",
      "priceSnapshot": "45.63",
      "availableForSale": true,
      "note": "Tepo option label alias → lighting style CQA-HSC-7W-DC-RGBCW"
    },
    "CQA-HSC-7W-RGBCW": {
      "cartVariantId": "67673808601314",
      "adminGid": "gid://shopify/ProductVariant/67673808601314",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-7W-RGBCW",
      "priceSnapshot": "42.77",
      "availableForSale": true
    },
    "CQA-HSC-9W": {
      "cartVariantId": "67673808568546",
      "adminGid": "gid://shopify/ProductVariant/67673808568546",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-9W",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSC-9W-DC": {
      "cartVariantId": "67673809092834",
      "adminGid": "gid://shopify/ProductVariant/67673809092834",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-9W-DC",
      "priceSnapshot": "38.81",
      "availableForSale": true
    },
    "CQA-HSF-7W-DC-RGBCW": {
      "cartVariantId": "67673809191138",
      "adminGid": "gid://shopify/ProductVariant/67673809191138",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-7W-DC-RGBCW",
      "priceSnapshot": "42.68",
      "availableForSale": true
    },
    "CQA-HSF-7W-RGBCW": {
      "cartVariantId": "67673808666850",
      "adminGid": "gid://shopify/ProductVariant/67673808666850",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-7W-RGBCW",
      "priceSnapshot": "39.12",
      "availableForSale": true
    },
    "CQA-HSF-9W": {
      "cartVariantId": "67673808634082",
      "adminGid": "gid://shopify/ProductVariant/67673808634082",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-9W",
      "priceSnapshot": "32.99",
      "availableForSale": true
    },
    "CQA-HSF-9W-DC": {
      "cartVariantId": "67673809158370",
      "adminGid": "gid://shopify/ProductVariant/67673809158370",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-9W-DC",
      "priceSnapshot": "35.85",
      "availableForSale": true
    },
    "CQA-HSSJZ-7W-DC-RGBCW": {
      "cartVariantId": "67673809256674",
      "adminGid": "gid://shopify/ProductVariant/67673809256674",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-7W-DC-RGBCW",
      "priceSnapshot": "43.89",
      "availableForSale": true
    },
    "CQA-HSSJZ-7W-RGBCW": {
      "cartVariantId": "67673808732386",
      "adminGid": "gid://shopify/ProductVariant/67673808732386",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-7W-RGBCW",
      "priceSnapshot": "40.40",
      "availableForSale": true
    },
    "CQA-HSSJZ-9W": {
      "cartVariantId": "67673808699618",
      "adminGid": "gid://shopify/ProductVariant/67673808699618",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-9W",
      "priceSnapshot": "34.23",
      "availableForSale": true
    },
    "CQA-HSSJZ-9W-DC": {
      "cartVariantId": "67673809223906",
      "adminGid": "gid://shopify/ProductVariant/67673809223906",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-9W-DC",
      "priceSnapshot": "37.07",
      "availableForSale": true
    },
    "CQA-HW-MG26-10W": {
      "cartVariantId": "47877686460642",
      "adminGid": "gid://shopify/ProductVariant/47877686460642",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG26-10W",
      "priceSnapshot": "35.29",
      "availableForSale": true
    },
    "CQA-HW-MG26-10W-RGBCW": {
      "cartVariantId": "47877686493410",
      "adminGid": "gid://shopify/ProductVariant/47877686493410",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG26-10W-RGBCW",
      "priceSnapshot": "44.39",
      "availableForSale": true
    },
    "CQA-HW-MG31-10W": {
      "cartVariantId": "47877686526178",
      "adminGid": "gid://shopify/ProductVariant/47877686526178",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG31-10W",
      "priceSnapshot": "43.95",
      "availableForSale": true
    },
    "CQA-HW-MG31-10W-RGBCW": {
      "cartVariantId": "47877686558946",
      "adminGid": "gid://shopify/ProductVariant/47877686558946",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG31-10W-RGBCW",
      "priceSnapshot": "53.08",
      "availableForSale": true
    },
    "CQA-HW-MG42-13W": {
      "cartVariantId": "47877686591714",
      "adminGid": "gid://shopify/ProductVariant/47877686591714",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG42-13W",
      "priceSnapshot": "58.84",
      "availableForSale": true
    },
    "CQA-HW-MG42-13W-RGBCW": {
      "cartVariantId": "47877686624482",
      "adminGid": "gid://shopify/ProductVariant/47877686624482",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG42-13W-RGBCW",
      "priceSnapshot": "69.96",
      "availableForSale": true
    },
    "CQA-HW-MG48-15W": {
      "cartVariantId": "47877686657250",
      "adminGid": "gid://shopify/ProductVariant/47877686657250",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG48-15W",
      "priceSnapshot": "78.68",
      "availableForSale": true
    },
    "CQA-HW-MG48-15W-RGBCW": {
      "cartVariantId": "47877686690018",
      "adminGid": "gid://shopify/ProductVariant/47877686690018",
      "productHandle": "lighting",
      "sku": "CQA-HW-MG48-15W-RGBCW",
      "priceSnapshot": "89.81",
      "availableForSale": true
    },
    "CQA-HW-YQ30-10W": {
      "cartVariantId": "47877686722786",
      "adminGid": "gid://shopify/ProductVariant/47877686722786",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ30-10W",
      "priceSnapshot": "38.35",
      "availableForSale": true
    },
    "CQA-HW-YQ30-10W-RGBCW": {
      "cartVariantId": "47877686755554",
      "adminGid": "gid://shopify/ProductVariant/47877686755554",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ30-10W-RGBCW",
      "priceSnapshot": "49.47",
      "availableForSale": true
    },
    "CQA-HW-YQ30-QW-10W": {
      "cartVariantId": "47877686788322",
      "adminGid": "gid://shopify/ProductVariant/47877686788322",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ30-QW-10W",
      "priceSnapshot": "83.23",
      "availableForSale": true
    },
    "CQA-HW-YQ30-QW-10W-RGBCW": {
      "cartVariantId": "47877686821090",
      "adminGid": "gid://shopify/ProductVariant/47877686821090",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ30-QW-10W-RGBCW",
      "priceSnapshot": "94.35",
      "availableForSale": true
    },
    "CQA-HW-YQ35-13W": {
      "cartVariantId": "47877686853858",
      "adminGid": "gid://shopify/ProductVariant/47877686853858",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ35-13W",
      "priceSnapshot": "44.39",
      "availableForSale": true
    },
    "CQA-HW-YQ35-13W-RGBCW": {
      "cartVariantId": "47877686886626",
      "adminGid": "gid://shopify/ProductVariant/47877686886626",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ35-13W-RGBCW",
      "priceSnapshot": "55.51",
      "availableForSale": true
    },
    "CQA-HW-YQ40-15W": {
      "cartVariantId": "47877686919394",
      "adminGid": "gid://shopify/ProductVariant/47877686919394",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ40-15W",
      "priceSnapshot": "48.91",
      "availableForSale": true
    },
    "CQA-HW-YQ40-15W-RGBCW": {
      "cartVariantId": "47877686952162",
      "adminGid": "gid://shopify/ProductVariant/47877686952162",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ40-15W-RGBCW",
      "priceSnapshot": "60.09",
      "availableForSale": true
    },
    "CQA-HW-YQ50-17W": {
      "cartVariantId": "47877686984930",
      "adminGid": "gid://shopify/ProductVariant/47877686984930",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ50-17W",
      "priceSnapshot": "62.70",
      "availableForSale": true
    },
    "CQA-HW-YQ50-17W-RGBCW": {
      "cartVariantId": "47877687017698",
      "adminGid": "gid://shopify/ProductVariant/47877687017698",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ50-17W-RGBCW",
      "priceSnapshot": "83.20",
      "availableForSale": true
    },
    "CQA-HW-YQ50-QW-17W": {
      "cartVariantId": "47877687050466",
      "adminGid": "gid://shopify/ProductVariant/47877687050466",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ50-QW-17W",
      "priceSnapshot": "133.23",
      "availableForSale": true
    },
    "CQA-HW-YQ50-QW-17W-RGBCW": {
      "cartVariantId": "47877687083234",
      "adminGid": "gid://shopify/ProductVariant/47877687083234",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQ50-QW-17W-RGBCW",
      "priceSnapshot": "144.38",
      "availableForSale": true
    },
    "CQA-HW-YQPC12-10W": {
      "cartVariantId": "67673808339170",
      "adminGid": "gid://shopify/ProductVariant/67673808339170",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HW-YQPC12-10W",
      "priceSnapshot": "14.55",
      "availableForSale": true
    },
    "CQA-HW-YQPC12-10W-RGBCW": {
      "cartVariantId": "47877687148770",
      "adminGid": "gid://shopify/ProductVariant/47877687148770",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQPC12-10W-RGBCW",
      "priceSnapshot": "23.71",
      "availableForSale": true
    },
    "CQA-HW-YQPC15-12W": {
      "cartVariantId": "47877687181538",
      "adminGid": "gid://shopify/ProductVariant/47877687181538",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQPC15-12W",
      "priceSnapshot": "17.26",
      "availableForSale": true
    },
    "CQA-HW-YQPC15-12W-RGBCW": {
      "cartVariantId": "47877687214306",
      "adminGid": "gid://shopify/ProductVariant/47877687214306",
      "productHandle": "lighting",
      "sku": "CQA-HW-YQPC15-12W-RGBCW",
      "priceSnapshot": "28.41",
      "availableForSale": true
    },
    "CQA-PC-D150-5W": {
      "cartVariantId": "67673808961762",
      "adminGid": "gid://shopify/ProductVariant/67673808961762",
      "productHandle": "leaves-lighting",
      "sku": "CQA-PC-D150-5W",
      "priceSnapshot": "49.37",
      "availableForSale": true
    },
    "CQA-PC-D180-5W": {
      "cartVariantId": "47877687279842",
      "adminGid": "gid://shopify/ProductVariant/47877687279842",
      "productHandle": "lighting",
      "sku": "CQA-PC-D180-5W",
      "priceSnapshot": "55.63",
      "availableForSale": true
    },
    "CQA-PC-D200-5.5W": {
      "cartVariantId": "67673808994530",
      "adminGid": "gid://shopify/ProductVariant/67673808994530",
      "productHandle": "leaves-lighting",
      "sku": "CQA-PC-D200-5.5W",
      "priceSnapshot": "72.24",
      "availableForSale": true
    },
    "CQA-PC-D225-5.5W": {
      "cartVariantId": "47877687345378",
      "adminGid": "gid://shopify/ProductVariant/47877687345378",
      "productHandle": "lighting",
      "sku": "CQA-PC-D225-5.5W",
      "priceSnapshot": "85.38",
      "availableForSale": true
    },
    "CQA-PC-VS125-5W": {
      "cartVariantId": "47877687378146",
      "adminGid": "gid://shopify/ProductVariant/47877687378146",
      "productHandle": "lighting",
      "sku": "CQA-PC-VS125-5W",
      "priceSnapshot": "68.13",
      "availableForSale": true
    },
    "CQA-PC-VS150-5.5W": {
      "cartVariantId": "47877687410914",
      "adminGid": "gid://shopify/ProductVariant/47877687410914",
      "productHandle": "lighting",
      "sku": "CQA-PC-VS150-5.5W",
      "priceSnapshot": "92.08",
      "availableForSale": true
    },
    "CQA-SZ-10W": {
      "cartVariantId": "67673808470242",
      "adminGid": "gid://shopify/ProductVariant/67673808470242",
      "productHandle": "leaves-lighting",
      "sku": "CQA-SZ-10W",
      "priceSnapshot": "25.67",
      "availableForSale": true
    },
    "CQA-VR175-300-5W": {
      "cartVariantId": "47877687476450",
      "adminGid": "gid://shopify/ProductVariant/47877687476450",
      "productHandle": "lighting",
      "sku": "CQA-VR175-300-5W",
      "priceSnapshot": "80.09",
      "availableForSale": true
    },
    "CQA-VR175-400-5W": {
      "cartVariantId": "47877687509218",
      "adminGid": "gid://shopify/ProductVariant/47877687509218",
      "productHandle": "lighting",
      "sku": "CQA-VR175-400-5W",
      "priceSnapshot": "84.23",
      "availableForSale": true
    },
    "CQA-XBJW-7W": {
      "cartVariantId": "67673808503010",
      "adminGid": "gid://shopify/ProductVariant/67673808503010",
      "productHandle": "leaves-lighting",
      "sku": "CQA-XBJW-7W",
      "priceSnapshot": "27.10",
      "availableForSale": true
    },
    "CQA-XBJW-24V-7W-DC": {
      "cartVariantId": "47877687574754",
      "adminGid": "gid://shopify/ProductVariant/47877687574754",
      "productHandle": "lighting",
      "sku": "CQA-XBJW-24V-7W-DC",
      "priceSnapshot": "31.80",
      "availableForSale": true
    },
    "CQA-XMY-12W": {
      "cartVariantId": "47877687607522",
      "adminGid": "gid://shopify/ProductVariant/47877687607522",
      "productHandle": "lighting",
      "sku": "CQA-XMY-12W",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "CQ-RXXTD02-12W": {
      "cartVariantId": "67673809060066",
      "adminGid": "gid://shopify/ProductVariant/67673809060066",
      "productHandle": "leaves-lighting",
      "sku": "CQ-RXXTD02-12W",
      "priceSnapshot": "22.46",
      "availableForSale": true
    },
    "LNT-HSC-7W-RGBCW-A": {
      "cartVariantId": "67673809387746",
      "adminGid": "gid://shopify/ProductVariant/67673809387746",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSC-7W-RGBCW-A",
      "priceSnapshot": "49.40",
      "availableForSale": true
    },
    "LNT-HSC-7W-RGBCW-B": {
      "cartVariantId": "67673809322210",
      "adminGid": "gid://shopify/ProductVariant/67673809322210",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSC-7W-RGBCW-B",
      "priceSnapshot": "46.51",
      "availableForSale": true
    },
    "LNT-HSC-9W": {
      "cartVariantId": "67673809354978",
      "adminGid": "gid://shopify/ProductVariant/67673809354978",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSC-9W",
      "priceSnapshot": "46.13",
      "availableForSale": true
    },
    "LNT-HSC-W-9W": {
      "cartVariantId": "67673809289442",
      "adminGid": "gid://shopify/ProductVariant/67673809289442",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSC-W-9W",
      "priceSnapshot": "43.24",
      "availableForSale": true
    },
    "LNT-HSF-7W-RGBCW-A": {
      "cartVariantId": "67673809518818",
      "adminGid": "gid://shopify/ProductVariant/67673809518818",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSF-7W-RGBCW-A",
      "priceSnapshot": "46.51",
      "availableForSale": true
    },
    "LNT-HSF-7W-RGBCW-B": {
      "cartVariantId": "67673809453282",
      "adminGid": "gid://shopify/ProductVariant/67673809453282",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSF-7W-RGBCW-B",
      "priceSnapshot": "42.68",
      "availableForSale": true
    },
    "LNT-HSF-9W": {
      "cartVariantId": "67673809486050",
      "adminGid": "gid://shopify/ProductVariant/67673809486050",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSF-9W",
      "priceSnapshot": "42.96",
      "availableForSale": true
    },
    "LNT-HSF-W-9W": {
      "cartVariantId": "67673809420514",
      "adminGid": "gid://shopify/ProductVariant/67673809420514",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSF-W-9W",
      "priceSnapshot": "40.09",
      "availableForSale": true
    },
    "LNT-HSSJZ-7W-RGBCW-A": {
      "cartVariantId": "67673809649890",
      "adminGid": "gid://shopify/ProductVariant/67673809649890",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSSJZ-7W-RGBCW-A",
      "priceSnapshot": "47.82",
      "availableForSale": true
    },
    "LNT-HSSJZ-7W-RGBCW-B": {
      "cartVariantId": "67673809584354",
      "adminGid": "gid://shopify/ProductVariant/67673809584354",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSSJZ-7W-RGBCW-B",
      "priceSnapshot": "43.95",
      "availableForSale": true
    },
    "LNT-HSSJZ-9W": {
      "cartVariantId": "67673809617122",
      "adminGid": "gid://shopify/ProductVariant/67673809617122",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSSJZ-9W",
      "priceSnapshot": "44.23",
      "availableForSale": true
    },
    "LNT-HSSJZ-W-9W": {
      "cartVariantId": "67673809551586",
      "adminGid": "gid://shopify/ProductVariant/67673809551586",
      "productHandle": "leaves-lighting",
      "sku": "LNT-HSSJZ-W-9W",
      "priceSnapshot": "37.04",
      "availableForSale": true
    },
    "LNT-HW-YQPC12-10W": {
      "cartVariantId": "47877688066274",
      "adminGid": "gid://shopify/ProductVariant/47877688066274",
      "productHandle": "lighting",
      "sku": "LNT-HW-YQPC12-10W",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "LNT-HW-YQPC12-10W-RGBCW": {
      "cartVariantId": "47877688099042",
      "adminGid": "gid://shopify/ProductVariant/47877688099042",
      "productHandle": "lighting",
      "sku": "LNT-HW-YQPC12-10W-RGBCW",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "LNT-XBJW-7W": {
      "cartVariantId": "47877688131810",
      "adminGid": "gid://shopify/ProductVariant/47877688131810",
      "productHandle": "lighting",
      "sku": "LNT-XBJW-7W",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "LNT-XBJW-W-7W": {
      "cartVariantId": "47877688164578",
      "adminGid": "gid://shopify/ProductVariant/47877688164578",
      "productHandle": "lighting",
      "sku": "LNT-XBJW-W-7W",
      "priceSnapshot": "999.00",
      "availableForSale": true
    },
    "LNT-ZTSD-7W-RGBCW": {
      "cartVariantId": "67673809715426",
      "adminGid": "gid://shopify/ProductVariant/67673809715426",
      "productHandle": "leaves-lighting",
      "sku": "LNT-ZTSD-7W-RGBCW",
      "priceSnapshot": "43.55",
      "availableForSale": true
    },
    "LNT-ZTSD-9W": {
      "cartVariantId": "67673809682658",
      "adminGid": "gid://shopify/ProductVariant/67673809682658",
      "productHandle": "leaves-lighting",
      "sku": "LNT-ZTSD-9W",
      "priceSnapshot": "25.04",
      "availableForSale": true
    },
    "CQA-HW-YQPC15-13W": {
      "cartVariantId": "67673808371938",
      "adminGid": "gid://shopify/ProductVariant/67673808371938",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HW-YQPC15-13W",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HW-YQPC12-10W-MS-RGBCW": {
      "cartVariantId": "67673808404706",
      "adminGid": "gid://shopify/ProductVariant/67673808404706",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HW-YQPC12-10W-MS-RGBCW",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HW-YQPC15-13W-RGBCW": {
      "cartVariantId": "67673808437474",
      "adminGid": "gid://shopify/ProductVariant/67673808437474",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HW-YQPC15-13W-RGBCW",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSC-7W-BS-RGBCW": {
      "cartVariantId": "67673808765154",
      "adminGid": "gid://shopify/ProductVariant/67673808765154",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-7W-BS-RGBCW",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSF-7W-BS-RGBCW": {
      "cartVariantId": "67673808797922",
      "adminGid": "gid://shopify/ProductVariant/67673808797922",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-7W-BS-RGBCW",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSSJZ-7W-BS-RGBCW": {
      "cartVariantId": "67673808830690",
      "adminGid": "gid://shopify/ProductVariant/67673808830690",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-7W-BS-RGBCW",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSC-9W-BS": {
      "cartVariantId": "67673808863458",
      "adminGid": "gid://shopify/ProductVariant/67673808863458",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSC-9W-BS",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSF-9W-BS": {
      "cartVariantId": "67673808896226",
      "adminGid": "gid://shopify/ProductVariant/67673808896226",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSF-9W-BS",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-HSSJZ-9W-BS": {
      "cartVariantId": "67673808928994",
      "adminGid": "gid://shopify/ProductVariant/67673808928994",
      "productHandle": "leaves-lighting",
      "sku": "CQA-HSSJZ-9W-BS",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "CQA-PC-FB220-5.5W": {
      "cartVariantId": "67673809027298",
      "adminGid": "gid://shopify/ProductVariant/67673809027298",
      "productHandle": "leaves-lighting",
      "sku": "CQA-PC-FB220-5.5W",
      "priceSnapshot": "0.00",
      "availableForSale": true
    },
    "ZCHW-F-P-80": {
      "cartVariantId": "67673810338018",
      "adminGid": "gid://shopify/ProductVariant/67673810338018",
      "productHandle": "leaves-lnt",
      "sku": "ZCHW-F-P-80",
      "priceSnapshot": "18.00",
      "availableForSale": true
    },
    "ZCHW-Y-P-80": {
      "cartVariantId": "67673810370786",
      "adminGid": "gid://shopify/ProductVariant/67673810370786",
      "productHandle": "leaves-lnt",
      "sku": "ZCHW-Y-P-80",
      "priceSnapshot": "17.26",
      "availableForSale": true
    }
  },
  "tracksBySize": {
    "ZCHW-F-P-50": {
      "cartVariantId": "47877695602914",
      "adminGid": "gid://shopify/ProductVariant/47877695602914",
      "productHandle": "lnt",
      "sku": "ZCHW-F-P-50",
      "priceSnapshot": "14.55",
      "availableForSale": true
    },
    "ZCHW-F-P-80": {
      "cartVariantId": "47877695635682",
      "adminGid": "gid://shopify/ProductVariant/47877695635682",
      "productHandle": "lnt",
      "sku": "ZCHW-F-P-80",
      "priceSnapshot": "18.00",
      "availableForSale": true
    },
    "ZCHW-Y-P-80": {
      "cartVariantId": "47877695701218",
      "adminGid": "gid://shopify/ProductVariant/47877695701218",
      "productHandle": "lnt",
      "sku": "ZCHW-Y-P-80",
      "priceSnapshot": "17.26",
      "availableForSale": true
    },
    "ZCHW-Y-P-150": {
      "cartVariantId": "47877695733986",
      "adminGid": "gid://shopify/ProductVariant/47877695733986",
      "productHandle": "lnt",
      "sku": "ZCHW-Y-P-150",
      "priceSnapshot": "27.79",
      "availableForSale": true
    },
    "ZCHW-Y-P-200": {
      "cartVariantId": "47877695766754",
      "adminGid": "gid://shopify/ProductVariant/47877695766754",
      "productHandle": "lnt",
      "sku": "ZCHW-Y-P-200",
      "priceSnapshot": "35.23",
      "availableForSale": true
    }
  },
  "accessoriesByStyle": {
    "GDJ": {
      "cartVariantId": "47960509972706",
      "adminGid": "gid://shopify/ProductVariant/47960509972706",
      "productHandle": "配件",
      "sku": "GDJ",
      "priceSnapshot": "1.74",
      "availableForSale": true
    },
    "CQ-GS": {
      "cartVariantId": "47960510005474",
      "adminGid": "gid://shopify/ProductVariant/47960510005474",
      "productHandle": "配件",
      "sku": "CQ-GS",
      "priceSnapshot": "18.66",
      "availableForSale": true
    }
  },
  "adapter": null,
  "splittersByBranchCount": {
    "1": null,
    "2": null,
    "3": null
  },
  "notes": [
    "Prices in this file are snapshots for review only. Runtime quotes use /products/{handle}.js.",
    "installationsById synced 2026-09-18 from live product pages (Tepo option set ids + default variants).",
    "Fixture lists in leaves-configurator-rules.js match Basic/Vibrant Lighting options on those 8 products.",
    "Spot sets and Multiple lighting are intentionally excluded from the configurator.",
    "配件 currently exposes GDJ and CQ-GS only; do not auto-map them as 一分二/一分三."
  ]
};
})(window);
